interface PositionSizerProps {
  entry?: number;
  stop?: number;
  nav?: number;
  maxPositionPct?: number;
  maxRiskPct?: number;
  recommendedQty?: number;
  maxByStop?: number;
  maxBySize?: number;
}

export function PositionSizer({
  entry,
  stop,
  nav,
  maxPositionPct = 0.25,
  maxRiskPct = 0.015,
  recommendedQty,
  maxByStop: suppliedMaxByStop,
  maxBySize: suppliedMaxBySize,
}: PositionSizerProps) {
  const riskPerShare = entry !== undefined && stop !== undefined ? Math.abs(entry - stop) : 0;
  const maxByStop =
    suppliedMaxByStop ??
    (nav && riskPerShare > 0 ? Math.floor((nav * maxRiskPct) / riskPerShare) : 0);
  const maxBySize =
    suppliedMaxBySize ?? (nav && entry ? Math.floor((nav * maxPositionPct) / entry) : 0);
  const qty = recommendedQty ?? Math.max(0, Math.min(maxByStop, maxBySize));
  const risk = qty * riskPerShare;
  const riskPct = nav && nav > 0 ? risk / nav : 0;

  return (
    <section className="rounded border border-border bg-surface p-4">
      <h2 className="text-lg font-semibold">Position sizer</h2>
      <div className="mt-3 grid grid-cols-2 gap-3 text-sm">
        <Metric label="Recommended qty" value={qty.toLocaleString()} />
        <Metric label="Max by stop" value={maxByStop.toLocaleString()} />
        <Metric label="Max by size" value={maxBySize.toLocaleString()} />
        <Metric
          label="$ risk"
          value={risk.toLocaleString(undefined, { maximumFractionDigits: 2 })}
        />
        <Metric label="Risk % of equity" value={`${(riskPct * 100).toFixed(2)}%`} />
      </div>
    </section>
  );
}

function Metric({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="text-xs text-text-muted">{label}</p>
      <p className="font-mono text-base tabular-nums">{value}</p>
    </div>
  );
}
